export default __webpack_public_path__ + "static/media/external-link.ef26a0ae.svg";